import { Grid, makeStyles, FormControl, FormHelperText, InputLabel, Input } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import { useOrders } from '../../hooks/Features/useOrders'
import { useLead } from '../../hooks/Features/useLeads'
import { formatDate, formatNumber, handleFile, ROUTES } from '../../shared/constants'
import { useHistory, useLocation } from 'react-router-dom'
import classes from './Lead.module.css'
import CustomerGrid from './CustomerGrid'
import CustomDialog from '../../components/CustomDialog'
import Button from '@material-ui/core/Button'
import HeadingWithCloseIcon from '../../components/HeadingWithCloseIcon'

export default function AddOrder() {
  const params = useParams()
  const { getLead, lead } = useLead()
  const { loading, addOrder } = useOrders()
  const history = useHistory()
  const [count, setCount] = useState(0)
  const [orderForm, setOrderForm] = useState({})
  const [open, setOpen] = useState(false)
  const [invoiceLoading, setInvoiceLoading] = useState(false)
  const [partialIndex, setPartialIndex] = useState([])
  const [partialAmount, setPartialAmount] = useState(0)

  useEffect(() => {
    getLead({ leadId: params.leadId })
  }, [params.leadId])

  useEffect(() => {
    if (lead) {
      let tempCount = 0
      lead.wishlist.forEach((item) => {
        tempCount += item.quantity
      })
      setCount(tempCount)
      setOrderForm({
        invoiceNo: '',
        invoiceImg: '',
        discount: lead.totalDiscount,
        price: lead.leadAmount,
        product: lead.wishlist,
        leadId: params.leadId,
        leadStatus: 'SUCCESS',
        discountType: lead.discountType,
        remarks: '',
      })
    }
  }, [lead])

  const calcTotalPrice = (leadAmount) => {
    if (lead.discountType === 'PERCENTAGE') return (leadAmount * 100) / (100 - lead.totalDiscount)
    else return leadAmount + lead.totalDiscount
  }

  const handleAddOrder = () => {
    let tempOrderForm = { ...orderForm }
    if (tempOrderForm.leadStatus === 'PARTIAL SUCCESS') {
      let tempWishList = partialIndex.map((item) => {
        let tempProduct = lead.wishlist[item]
        return {
          productId: tempProduct.productId._id,
          quantity: tempProduct.quantity,
        }
      })
      tempOrderForm.product = tempWishList
      tempOrderForm.price = partialAmount
    } else {
      tempOrderForm.product = lead.wishlist.map((item) => {
        return {
          productId: item.productId._id,
          quantity: item.quantity,
        }
      })
      tempOrderForm.price = lead.leadAmount
    }

    //console.log('final order ', tempOrderForm)
    addOrder(tempOrderForm)
  }

  const handleInvoiceChange = (e) => {
    handleFile(e, setInvoiceLoading, (invoiceUrl) => setOrderForm({ ...orderForm, invoiceImg: invoiceUrl }))
  }

  const handlePartialChange = (e) => {
    let tempArr = [...partialIndex]
    if (e.target.checked) {
      setPartialIndex([...partialIndex, parseInt(e.target.id)])
      tempArr = [...partialIndex, parseInt(e.target.id)]
    } else {
      var removeIndex = partialIndex.indexOf(parseInt(e.target.id))
      if (removeIndex > -1) {
        tempArr.splice(removeIndex, 1)
        setPartialIndex(tempArr)
      }
    }
    let tempPrice = 0
    tempArr.forEach((item) => {
      tempPrice += lead.wishlist[item].productId.dealerPrice * lead.wishlist[item].quantity
    })

    if (lead.discountType === 'PERCENTAGE') tempPrice = ((tempPrice * (100 - lead.totalDiscount)) / 100).toFixed(2)
    else tempPrice -= lead.totalDiscount

    setPartialAmount(tempPrice)
  }

  return (
    <Layout heading="Leads" heading2="Add" url1={ROUTES.LEADS} none>
      <CustomDialog open={open} handleClose={() => setOpen(false)}>
        <HeadingWithCloseIcon heading="Invoice" />
        {orderForm.leadStatus === 'PARTIAL SUCCESS' && (
          <div>
            <h4 style={{ textAlign: 'center' }}>Select Products</h4>
            {lead.wishlist.map((item, index) => {
              return (
                <Grid container style={{ margin: '10px 0' }}>
                  <Grid item lg={3} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <input onChange={handlePartialChange} id={index} style={{ height: '15px', width: '15px' }} type="checkbox" />
                  </Grid>
                  <Grid item lg={7} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <img src={item.productId && item.productId.primaryImage} width="70px" height="70px" />
                    <span></span>
                    {item.productId && item.productId.name}
                  </Grid>
                </Grid>
              )
            })}
            <br />
            Total Price: {formatNumber(partialAmount)}
          </div>
        )}
        <FormControl>
          <InputLabel htmlFor="invoiceNo">Invoice No.</InputLabel>
          <Input style={{ width: '20rem' }} id="invoiceNo" aria-describedby="invoiceNoHelper" onChange={(e) => setOrderForm({ ...orderForm, invoiceNo: e.target.value })} />
        </FormControl>
        <br />
        <FormControl>
          <InputLabel htmlFor="invoiceImg">Invoice Image</InputLabel>
          <Input disabled={invoiceLoading} style={{ width: '20rem' }} type="file" id="invoiceImg" aria-describedby="invoiceImgHelper" onChange={handleInvoiceChange} />
          {invoiceLoading && <Loader />}
        </FormControl>
        <br />
        <FormControl>
          <InputLabel htmlFor="remarks">Remarks</InputLabel>
          <Input style={{ width: '20rem' }} id="remarks" aria-describedby="remarksHelper" onChange={(e) => setOrderForm({ ...orderForm, remarks: e.target.value })} />
        </FormControl>
        <br />
        {orderForm.leadStatus === 'PARTIAL SUCCESS' && partialIndex.length === lead.wishlist.length && <span style={{ color: 'red' }}>You can not select All Products in Partial Order</span>}
        <br />
        <Button
          style={{ width: '10rem' }}
          variant="contained"
          color="primary"
          onClick={() => {
            setOpen(false)
            setPartialIndex([])
            setPartialAmount(0)
          }}
        >
          Cancel
        </Button>
        <Button
          style={{ float: 'right', width: '10rem' }}
          disabled={
            loading || !orderForm.invoiceImg || !orderForm.invoiceNo || (orderForm.leadStatus === 'PARTIAL SUCCESS' && (partialIndex.length === 0 || partialIndex.length === lead.wishlist.length))
          }
          variant="contained"
          color="primary"
          onClick={handleAddOrder}
        >
          Confirm
        </Button>
      </CustomDialog>
      {lead ? (
        <Grid container style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
          <Grid item lg={5}>
            <CustomerGrid
              leadTypeName={lead.status && lead.status.name}
              profilePicture={lead.customer && lead.customer.profilePicture}
              customerState={lead.customer && lead.customer.state}
              customerCity={lead.customer && lead.customer.city}
              customerName={lead.customer && lead.customer.name}
              editUrl={`/edit-lead/${params.leadId}`} // not working , going to edit page but customer is not shown
            />
          </Grid>

          <Grid item container lg={5} className={classes.finalLead}>
            <Grid item lg={5} className={classes.finalLeadLeftSection}>
              <div>Quote Number : {lead.quoteNumber}</div>
              <div>Created On {formatDate(lead.createdAt)}</div>
              <div>modified on {formatDate(lead.updatedAt)}</div>
              <br />
              <div>
                Add Quote status <span className={classes.quoteStatus}>{lead.leadStatus}</span>
              </div>
            </Grid>
            <Grid item lg={7} className={classes.finalLeadRightSection}>
              <div>
                <strong>Summary</strong>
              </div>
              <div>
                Price({count} item{count > 1 ? 's' : ''})<span className={classes.price}>{formatNumber(calcTotalPrice(lead.leadAmount))}</span>
              </div>
              <div>
                Selling Price
                <span className={classes.price}>{formatNumber(calcTotalPrice(lead.leadAmount))}</span>
              </div>

              <div>
                Discount Offered
                <span className={classes.price}>
                  {lead.discountType === 'AMOUNT' && '₹ '}
                  {lead.totalDiscount}
                  {lead.discountType === 'PERCENTAGE' && '%'} off -{formatNumber(calcTotalPrice(lead.leadAmount) - lead.leadAmount)}
                </span>
              </div>

              <hr style={{ height: '1px', color: 'blue' }} />
              <div>
                Total Amount
                <span className={classes.price}>{formatNumber(lead.leadAmount)}</span>
              </div>
              <hr style={{ height: '1px', color: 'blue' }} />
              <div style={{ textAlign: 'center' }}>
                {loading ? (
                  <Loader />
                ) : (
                  <React.Fragment>
                    <span
                      className={classes.quoteStatus}
                      onClick={() => {
                        setOrderForm({ ...orderForm, leadStatus: 'SUCCESS' })
                        setOpen(true)
                      }}
                    >
                      Convert To Full Order
                    </span>
                    <br />
                    <br />
                    <span
                      className={classes.quoteStatus}
                      onClick={() => {
                        setOrderForm({ ...orderForm, leadStatus: 'PARTIAL SUCCESS' })
                        setOpen(true)
                      }}
                    >
                      Convert To Partial Order
                    </span>
                  </React.Fragment>
                )}
              </div>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Loader />
      )}
      <br />
      {lead && lead.wishlist.length > 0 && (
        <div style={{ margin: '10px 50px' }}>
          <div>
            <strong>Products</strong>
          </div>
          <hr style={{ height: '1px', color: 'blue' }} />
          <Grid container>
            {lead.wishlist.map(({ productId, quantity }, index) => {
              let { name, dealerPrice, primaryImage, color } = productId
              return (
                <Grid className={classes.productGrid} item container lg={4} key={index}>
                  <Grid item lg={4}>
                    <div>
                      <img src={primaryImage} height="85px" width="76px" />
                    </div>
                  </Grid>

                  <Grid item lg={4}>
                    <div>
                      {name}
                      <br />
                      Color: {color}
                      <br />
                      {formatNumber(dealerPrice)}
                    </div>
                  </Grid>

                  <Grid item lg={4} style={{ textAlign: 'center' }}>
                    <span
                      style={{
                        backgroundColor: 'black',
                        color: 'white',
                        textAlign: 'center',
                        height: '30px',
                        padding: '5px 30px',
                        borderRadius: '20px',
                      }}
                    >
                      {quantity}
                    </span>
                  </Grid>
                </Grid>
              )
            })}
          </Grid>
        </div>
      )}
    </Layout>
  )
}
